import { BUSINESS } from "@/data/site";
import { scrollToId } from "@/lib/scroll";
import Icon from "@/components/Icon";
import { useLang } from "@/i18n";

export default function MobileCallBar() {
    const { t } = useLang();
    return (
        <div
            data-testid="mobile-call-bar"
            className="fixed bottom-0 left-0 right-0 z-40 md:hidden glass border-t border-white/10 px-4 py-3 flex gap-3"
            style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
        >
            <a
                data-testid="mobile-bar-call"
                href={BUSINESS.tel}
                className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-electric to-cyan2 py-3.5 font-bold text-white text-sm"
            >
                <Icon name="phone" size={16} />
                {t.mobileBar.call}
            </a>
            <button
                data-testid="mobile-bar-enquire"
                onClick={() => scrollToId("contact")}
                className="flex-1 inline-flex items-center justify-center gap-2 rounded-full border border-ink/30 py-3.5 font-semibold text-ink text-sm"
            >
                {t.mobileBar.enquire}
                <Icon name="arrow" size={15} />
            </button>
        </div>
    );
}
